// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Panel":"beo_a bih_ea bih_ke bih_ju bih_sn bih_wl"};